export default __webpack_public_path__ + "static/media/dlp.348f3600.png";